// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2pm8P","info":"PatientInfo_info__EeB4L"};